/* eslint-disable */
export default {
    install(Vue, options) {
        Vue.mixin({
            beforeCreate: function () {
                var instance = this
                this.$grid = {
                    getRecord: function (urlData, dataParams, $event) {
                        return new Promise(function (resolve, reject) {
                            instance.$ajax.get(urlData, dataParams).then(function (params) {
                                params.$event = $event
                                resolve(params)
                            }).catch(function (params) {
                                reject(params)
                            })
                        })
                    },
                    deleteRecord: function (url, dataParams, $event, index) {
                        return new Promise(function (resolve, reject) {
                            instance.$root.$confirm('Confirme', '¿Está seguro que quiere borrar el registro?')
                                .then(result => {
                                    if (result) {
                                        instance.loading = true
                                        instance.$ajax.post(url, dataParams).then(params => {
                                            params.$event = $event
                                            params.index = index
                                            resolve(params)
                                        }).catch(params => {
                                            instance.loading = false
                                            reject(params)
                                        })
                                    }
                                })
                        })
                    },
                    deleteRecordSuccess: function (params) {
                        instance.loading = false
                        if (params.data === "OK") {
                            instance.rows.splice(params.index, 1)
                            instance.$root.$snackbar('¡El registro ha sido eliminado con éxito!', { color: 'success' })
                        }
                        else if (params.data === "ERROR") {
                            instance.$root.$snackbar('Se produjo un error al intentar eliminar el registro.\
                            El registro puede tener dependientes en otros registros.\
                            Elimine todos los registros asociados con este registro y luego intente eliminar este registro nuevamente.', { color: 'error' })
                        }
                        else
                            instance.$root.$snackbar("Se produjo un error desconocido al intentar eliminar el registro", { color: 'error' })
                    }
                }
            }
        })
    }
}



// WEBPACK FOOTER //
// ./src/scripts/VueGridSetup.js